import React from 'react'
import AdvertisementComponent from './component/Advertisement'

function Advertisement() {
  return (
    <>
  <AdvertisementComponent/>
    </>
  )
}

export default Advertisement